import React from "react"

const Separator = <span className="footer__link-separator">·</span>

export default Separator
